import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, PartyPopper } from "lucide-react";
import JoinDiscord from "@/components/JoinDiscord";

// One-time, dismissible "Join our Discord" nudge shown once to brand-new signups.
export default function DiscordWelcome() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem("ts_new_signup") === "1" && localStorage.getItem("ts_discord_welcome_seen") !== "1") {
        setOpen(true);
      }
    } catch (_) {}
  }, []);

  const close = () => {
    try {
      localStorage.setItem("ts_discord_welcome_seen", "1");
      localStorage.removeItem("ts_new_signup");
    } catch (_) {}
    setOpen(false);
  };

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 px-4" onClick={close} data-testid="discord-welcome-modal">
      <div className="osrs-panel p-6 w-full max-w-sm text-center relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} className="osrs-btn px-2 py-1 absolute top-3 right-3" data-testid="discord-welcome-close" aria-label="Dismiss"><X size={15} /></button>

        <div className="flex justify-center mb-3">
          <div className="w-16 h-16 rounded-full bg-[#5865F2] border-2 border-black shadow-[3px_3px_0_#000] flex items-center justify-center">
            <PartyPopper size={30} className="text-white" />
          </div>
        </div>

        <h3 className="osrs-title osrs-text-glow text-2xl mb-2">Welcome, adventurer!</h3>
        <p className="osrs-shadow text-[#E6A519] text-sm leading-snug mb-1">
          Your account's all set. The TaskScape community lives on <span className="text-[#7C88F5] font-bold">Discord</span> —
        </p>
        <p className="osrs-shadow text-[#b9a06a] text-xs leading-snug mb-5">
          get task help, share drops, hear about updates, and follow the monthly <span className="text-[#FFCF3F]">free Bond</span> race. 🎉
        </p>

        <div className="flex flex-col gap-2 items-center">
          <div onClick={close}>
            <JoinDiscord variant="button" label="Join our Discord" />
          </div>
          <button onClick={close} className="osrs-shadow text-[#8a7a54] text-xs hover:text-[#E6A519] transition-colors mt-1" data-testid="discord-welcome-later">
            Maybe later
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
